<template>
  <Transition name="fade">
    <div
      v-if="isShowOverlay"
      class="overlay"
      @click="closeModals"
    />
  </Transition>
</template>
<script>
import { disableScroll, enableScroll } from '@/util/scroll-lock'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppOverlay',
  computed: {
    ...mapGetters('base', [
      'isDropdownOpen',
    ]),
    isShowOverlay() {
      return this.isDropdownOpen.sidebar
        || this.isDropdownOpen.messages
        || this.isDropdownOpen.balance
    },
  },
  watch: {
    isDropdownOpen: {
      handler(val) {
        if (val.sidebar) {
          this.$nextTick(() => {
            disableScroll()
          })
        }
        else if (val.messages) {
          this.$nextTick(() => {
            disableScroll()
          })
        }
        else if (val.balance) {
          this.$nextTick(() => {
            disableScroll()
          })
        }
        else {
          enableScroll()
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    enableScroll()
  },
  methods: {
    ...mapActions('base', [
      'closeDropdown',
    ]),
    closeModals() {
      this.closeDropdown()
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  overflow: hidden;
  background-color: var(--general-bg-backdrop);
}
</style>
